import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Default axios — no credentials, so preflight passes against `Access-Control-Allow-Origin: *`.
// Bookings, register, login, JWT-based /auth/me all work without cookies.
export const api = axios.create({
  baseURL: API,
  withCredentials: false,
});

// Use this ONLY for endpoints that rely on the httpOnly `session_token` cookie
// (i.e. Emergent OAuth callback + cookie-based /auth/me).
export const authApi = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function setAuthToken(token) {
  if (token) {
    localStorage.setItem("mc_token", token);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    authApi.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    localStorage.removeItem("mc_token");
    delete api.defaults.headers.common["Authorization"];
    delete authApi.defaults.headers.common["Authorization"];
  }
}

const existing = localStorage.getItem("mc_token");
if (existing) {
  api.defaults.headers.common["Authorization"] = `Bearer ${existing}`;
  authApi.defaults.headers.common["Authorization"] = `Bearer ${existing}`;
}
